











import { TranslateResult }           from 'vue-i18n';
import { computed, defineComponent } from '@vue/composition-api';
import { useGlobals }                from '@/hooks/use-globals';
import { Computed }                  from '@/types';
import cBreadcrumb                   from '@/components/breadcrumb/breadcrumb.component.vue';
import cFooterPanel                  from '@/components/footer-panel/footer-panel.component.vue';
import cSeasonsCalendar              from '@/views/seasons/components/seasons-calendar/seasons-calendar.component.vue';
import cSeasonsList                  from '@/views/seasons/components/seasons-list/seasons-list.component.vue';
import { getViewStorePath }          from '@/store/store.helpers';
import { name }                      from './seasons.route';

export default defineComponent({
  name: 'vSeasons',
  components: {
    cSeasonsCalendar,
    cBreadcrumb,
    cFooterPanel,
    cSeasonsList,
  },
  setup() {
    const { i18n, store } = useGlobals();
    const getBreadcrumbTranslation: Computed<TranslateResult> = computed(() => i18n.t('vSeasons.meta.breadcrumb'));
    const saveConfiguration = (): void => {
      store.dispatch(`${getViewStorePath(name)}/saveAllSeasons`);
    };
    store.dispatch(`${getViewStorePath(name)}/getAllSeasons`);
    return {
      saveConfiguration,
      getBreadcrumbTranslation,
    };
  },
});
